
(function(){
  'use strict';

  function esc(value){
    return String(value==null?'':value).replace(/[&<>"']/g,function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
    });
  }
  function safeLogo(value){
    var v=String(value||'').trim();
    return /^https:\/\//i.test(v)?v:'';
  }
  function money(cents){
    var n=Number(cents||0);
    return 'R'+(n/100).toLocaleString('en-ZA',{minimumFractionDigits:2,maximumFractionDigits:2});
  }
  function restoreForm(){
    var form=document.getElementById('pfhn-panel-form');
    var results=document.getElementById('pfhn-panel-results');
    var intro=document.getElementById('pfhn-panel-intro');
    if(form)form.hidden=false;
    if(results)results.hidden=true;
    if(intro)intro.hidden=true;
  }
  function closeLayer(layer){
    if(layer&&layer.parentNode)layer.parentNode.removeChild(layer);
    document.documentElement.classList.remove('pf-emx-open');
  }
  function buildLayer(payload){
    var old=document.querySelector('.pf-emx');
    if(old)old.remove();
    var layer=document.createElement('div');
    layer.className='pf-emx';
    layer.setAttribute('role','dialog');
    layer.setAttribute('aria-modal','true');
    layer.setAttribute('aria-label','ProFind Emergency matching');
    var mode=String(payload.response_mode||'')==='CUSTOMER_TO_PROVIDER'?'I can go to the provider':'Send someone to me';
    layer.innerHTML=
      '<div class="pf-emx__top">'+
        '<button type="button" class="pf-emx__back" aria-label="Back to Emergency request">‹</button>'+
        '<div class="pf-emx__brand">Pro<span>Find</span> Emergency</div>'+
        '<div class="pf-emx__secure">Secure matching</div>'+
      '</div>'+
      '<div class="pf-emx__body">'+
        '<section class="pf-emx__search" aria-live="polite">'+
          '<div class="pf-emx__radar" aria-hidden="true">'+
            '<span class="pf-emx__ring"></span><span class="pf-emx__ring"></span><span class="pf-emx__ring"></span>'+
            '<span class="pf-emx__core"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 6v6l4 2"></path><circle cx="12" cy="12" r="9"></circle></svg></span>'+
          '</div>'+
          '<p class="pf-emx__eyebrow">Emergency matching active</p>'+
          '<h2>Prioritising your emergency</h2>'+
          '<p class="pf-emx__stage">Checking verified providers who are on standby right now.</p>'+
          '<div class="pf-emx__progress" aria-hidden="true"><span></span></div>'+
          '<div class="pf-emx__rotate">Your Emergency request is being prioritised.</div>'+
          '<div class="pf-emx__chips">'+
            '<span class="pf-emx__chip">'+esc(payload.category||'Emergency service')+'</span>'+
            '<span class="pf-emx__chip">'+esc(payload.area_name||'Precise location')+'</span>'+
            '<span class="pf-emx__chip">'+esc(mode)+'</span>'+
          '</div>'+
          '<div class="pf-emx__trust"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"></path><path d="m9 12 2 2 4-4"></path></svg><span>ProFind checks Emergency eligibility, current standby status, response mode, service radius and available capacity before a provider is shown.</span></div>'+
        '</section>'+
        '<section class="pf-emx__options" hidden></section>'+
      '</div>';
    document.body.appendChild(layer);
    document.documentElement.classList.add('pf-emx-open');
    return layer;
  }
  function startSearchMotion(layer){
    var bar=layer.querySelector('.pf-emx__progress span');
    var stage=layer.querySelector('.pf-emx__stage');
    var rotate=layer.querySelector('.pf-emx__rotate');
    var progress=7;
    var messages=[
      'Your Emergency request is being prioritised.',
      'Checking verified providers who are on standby now.',
      'Comparing distance, response mode and live capacity.',
      'Preparing the fastest eligible options available.'
    ];
    var stages=[
      'Checking verified providers who are on standby right now.',
      'Confirming service radius and live capacity.',
      'Preparing the strongest available matches.'
    ];
    var mi=0,si=0;
    var progTimer=window.setInterval(function(){
      progress=Math.min(88,progress+(progress<55?6:(progress<75?3:1)));
      if(bar)bar.style.width=progress+'%';
    },430);
    var msgTimer=window.setInterval(function(){
      if(!document.body.contains(layer)){window.clearInterval(msgTimer);return;}
      mi=(mi+1)%messages.length;
      if(!rotate)return;
      rotate.classList.add('is-changing');
      window.setTimeout(function(){if(!document.body.contains(layer))return;rotate.textContent=messages[mi];rotate.classList.remove('is-changing');},170);
    },2100);
    var stageTimer=window.setInterval(function(){
      if(!document.body.contains(layer)){window.clearInterval(stageTimer);return;}
      si=Math.min(stages.length-1,si+1);
      if(stage)stage.textContent=stages[si];
      if(si===stages.length-1)window.clearInterval(stageTimer);
    },2400);
    return function(done){
      window.clearInterval(progTimer);window.clearInterval(msgTimer);window.clearInterval(stageTimer);
      if(done&&bar)bar.style.width='100%';
    };
  }
  function invokeOptions(payload){
    try{
      var client=window.ProFindData&&window.ProFindData.client&&window.ProFindData.client();
      if(!client||!client.functions||!client.functions.invoke)return Promise.resolve({data:null,error:{message:'Emergency matching unavailable'}});
      return client.functions.invoke('emergency-provider-options',{body:{
        category:payload.category,
        area_name:payload.area_name,
        response_mode:payload.response_mode,
        latitude:payload.latitude,
        longitude:payload.longitude
      }}).then(function(result){
        return {data:result&&result.data||null,error:result&&result.error||null};
      }).catch(function(error){return {data:null,error:error||{message:'Emergency matching unavailable'}};});
    }catch(error){
      return Promise.resolve({data:null,error:error});
    }
  }
  function providerCard(option,index){
    var logo=safeLogo(option.logo_url);
    var initial=esc((option.name||'P').charAt(0).toUpperCase());
    var rating=Number(option.rating||0);
    var reviews=Number(option.review_count||0);
    var distance=Number(option.distance_km);
    var response=Number(option.response_time_minutes);
    var fee=Number(option.emergency_fee_cents||0);
    var feeLabel=String(option.emergency_fee_type||'').toUpperCase()==='CONSULTATION'?'Consultation':'Call-out';
    var meta=[];
    if(Number.isFinite(distance))meta.push((distance<1?Math.max(1,Math.round(distance*1000))+' m':distance.toFixed(1)+' km')+' away');
    if(Number.isFinite(response)&&response>0&&response<9999)meta.push('Provider estimate ~'+Math.round(response)+' min');
    if(rating>0)meta.push('★ '+rating.toFixed(1)+(reviews>0?' · '+reviews+' review'+(reviews===1?'':'s'):''));
    if(fee>0)meta.push(feeLabel+' '+money(fee));
    if(option.fee_shield_available)meta.push('FeeShield eligible');
    return '<article class="pf-emx__provider'+(index===0?' pf-emx__provider--recommended':'')+'" data-provider="'+esc(option.business_id)+'">'+
      (index===0?'<span class="pf-emx__badge">Priority match</span>':'')+
      '<div class="pf-emx__provider-head">'+
        '<div class="pf-emx__logo">'+(logo?'<img src="'+esc(logo)+'" alt="" loading="eager">':initial)+'</div>'+
        '<div class="pf-emx__provider-name"><strong>'+esc(option.name||'ProFind provider')+'</strong><span class="pf-emx__standby">On standby now'+(option.verified?' · Verified':'')+'</span></div>'+
      '</div>'+
      '<div class="pf-emx__meta">'+meta.map(function(m){return '<span>'+esc(m)+'</span>';}).join('')+'</div>'+
      '<button type="button" data-choose-provider="'+esc(option.business_id)+'">Request this provider</button>'+
    '</article>';
  }
  function showOptions(layer,data,payload,onChoose,onCancel,alertText){
    var search=layer.querySelector('.pf-emx__search');
    var optionsSection=layer.querySelector('.pf-emx__options');
    var list=Array.isArray(data&&data.options)?data.options.slice(0,3):[];
    if(search)search.hidden=true;
    if(!optionsSection)return;
    optionsSection.hidden=false;
    optionsSection.innerHTML=
      '<div class="pf-emx__options-head">'+
        '<p class="pf-emx__eyebrow">Standby providers confirmed</p>'+
        '<h2>Choose who to contact first</h2>'+
        '<p>These providers are eligible for your request and currently on Emergency standby. Choose one and ProFind will re-check availability before dispatch.</p>'+
      '</div>'+
      (alertText?'<div class="pf-emx__alert">'+esc(alertText)+'</div>':'')+
      '<div class="pf-emx__provider-list">'+list.map(providerCard).join('')+'</div>'+
      '<div class="pf-emx__reroute"><strong>Built-in fallback:</strong> if your first choice becomes unavailable, declines or does not respond, ProFind keeps the Emergency request active and automatically tries the next eligible provider. You do not need to start again.</div>';
    optionsSection.querySelectorAll('[data-choose-provider]').forEach(function(button){
      button.addEventListener('click',function(){
        var id=button.getAttribute('data-choose-provider');
        var option=list.filter(function(x){return String(x.business_id)===String(id);})[0];
        if(!option)return;
        optionsSection.querySelectorAll('button').forEach(function(b){b.disabled=true;});
        button.textContent='Requesting…';
        onChoose(option);
      });
    });
    var back=layer.querySelector('.pf-emx__back');
    if(back)back.onclick=function(){onCancel();};
  }
  function showDispatching(layer,option){
    var search=layer.querySelector('.pf-emx__search');
    var opts=layer.querySelector('.pf-emx__options');
    if(opts)opts.hidden=true;
    if(search){
      search.hidden=false;
      var eyebrow=search.querySelector('.pf-emx__eyebrow');
      var title=search.querySelector('h2');
      var stage=search.querySelector('.pf-emx__stage');
      var rotate=search.querySelector('.pf-emx__rotate');
      var bar=search.querySelector('.pf-emx__progress span');
      if(eyebrow)eyebrow.textContent='Provider selected';
      if(title)title.textContent='Sending your request';
      if(stage)stage.textContent='Re-checking '+String(option.name||'the provider')+' and locking the request to their standby queue.';
      if(rotate)rotate.textContent='You will not need to restart if this provider becomes unavailable.';
      if(bar)bar.style.width='96%';
    }
  }
  function boot(){
    if(!window.ProFindData||typeof window.ProFindData.createEmergencyRequest!=='function'||typeof window.ProFindData.client!=='function'){
      window.setTimeout(boot,180);
      return;
    }
    if(window.ProFindData.createEmergencyRequest.__pfEmergencyUXV2)return;

    var original=window.ProFindData.createEmergencyRequest.bind(window.ProFindData);

    function wrapped(payload){
      payload=payload||{};
      if(payload.selected_business_id||payload.__pf_skip_provider_picker)return original(payload);

      var layer=buildLayer(payload);
      var stopMotion=startSearchMotion(layer);
      var started=Date.now();

      return new Promise(function(resolve){
        var finished=false;
        function finish(result){
          if(finished)return;
          finished=true;
          stopMotion(true);
          closeLayer(layer);
          resolve(result);
        }
        function fallbackToOriginal(note){
          var stage=layer.querySelector('.pf-emx__stage');
          var rotate=layer.querySelector('.pf-emx__rotate');
          if(stage)stage.textContent=note||'Continuing with ProFind Emergency matching.';
          if(rotate)rotate.textContent='Keeping your Emergency request moving without making you start again.';
          var delay=Math.max(0,650-(Date.now()-started));
          window.setTimeout(function(){original(payload).then(finish);},delay);
        }
        function cancel(){
          if(finished)return;
          finished=true;
          stopMotion(false);
          closeLayer(layer);
          restoreForm();
          resolve({data:null,error:{message:'Provider selection cancelled.',cancelled:true}});
        }
        function loadChoices(alertText){
          invokeOptions(payload).then(function(result){
            if(finished)return;
            var data=result&&result.data;
            if(result&&result.error){
              fallbackToOriginal('Matching is taking a little longer. Continuing securely.');
              return;
            }
            if(data&&data.code==='PRE_LAUNCH'){
              fallbackToOriginal('Emergency matching is not live yet. Keeping this preview safe.');
              return;
            }
            var list=Array.isArray(data&&data.options)?data.options:[];
            if(!list.length){
              fallbackToOriginal('No standby provider is confirmed nearby yet. Checking the normal Emergency fallback.');
              return;
            }
            var reveal=function(){
              if(finished)return;
              stopMotion(true);
              window.setTimeout(function(){
                if(finished)return;
                showOptions(layer,data,payload,function(option){
                  payload.selected_business_id=option.business_id;
                  payload.selected_service_id=option.service_id;
                  showDispatching(layer,option);
                  original(payload).then(function(result2){
                    if(result2&&result2.error&&Number(result2.error.status)===409){
                      delete payload.selected_business_id;
                      delete payload.selected_service_id;
                      loadChoices('That provider just became unavailable. We refreshed the standby list for you.');
                      return;
                    }
                    finish(result2);
                  });
                },cancel,alertText);
              },180);
            };
            var wait=Math.max(0,560-(Date.now()-started));
            window.setTimeout(reveal,wait);
          });
        }
        var back=layer.querySelector('.pf-emx__back');
        if(back)back.addEventListener('click',cancel,{once:true});
        loadChoices('');
      });
    }
    wrapped.__pfEmergencyUXV2=true;
    wrapped.__original=original;
    window.ProFindData.createEmergencyRequest=wrapped;
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }
  window.setTimeout(boot,700);
})();
